export const chartColors = {
  demographics: {
    default: '#C7C7BE',
    colors: ['#BB8C23', '#254699', '#A1C490', '#3F6E3B', '#C1A9C6', '#4E2E77', '#D6A97F'],
  },
  demand: ['#B9C9A1', '#8AAE6F', '#628C42', '#375E29', '#27492C'],
  supply: ['#510C0C', '#881B1B', '#B23A3A', '#CE7474', '#E8B0B0'],
  supplyDemand: ['#B23A3A', '#628C42'],
  distributionPreview: ['#BB8C23', '#254699', '#A1C490', '#3F6E3B'],
  tokenDesigner: [
    '#BB8C23',
    '#254699',
    '#A1C490',
    '#3F6E3B',
    '#C1A9C6',
    '#4E2E77',
    '#D6A97F',
    '#C55E00',
    '#D99393',
    '#972323',
    '#DB9700',
    '#2C5CD7',
    '#89C563',
    '#0B8300',
    '#9C6FD6',
    '#510FA7',
    '#F8A75B',
    '#EE5600',
    '#FFAAAA',
    '#CC0000',
  ],
  tokenUnlocks: [
    '#BB8C23',
    '#254699',
    '#A1C490',
    '#3F6E3B',
    '#C1A9C6',
    '#4E2E77',
    '#D6A97F',
    '#C55E00',
    '#D99393',
    '#972323',
    // DUPLIcates so it doesn't look super-brown
    '#3F6E3B',
    '#C1A9C6',
  ],
  mmm: ['#254699', '#BB8C23', '#C7C7BE4D', '#254699', '#BB8C23'],
  unovis: ['#4D8CFD', '#FF6B7E', '#F4B83E', '#A6CC74', '#00C19A', '#6f5aec'],
  trend: {
    '1': '#057a55',
    '0': '#374151',
    '-1': '#dc2626',
  },
} as const

/**
 * Apply an alpha value to a hex color string, returning an `rgba()` color.
 *
 * @param hex    A hex color (e.g. `"#254699"` or `"#fff"`)
 * @param alpha  Opacity from 0 to 1
 */
export function withAlpha(hex: string, alpha: number) {
  const h = hex.replace('#', '')
  const full =
    h.length === 3
      ? h
          .split('')
          .map((c) => c + c)
          .join('')
      : h
  const r = Number.parseInt(full.slice(0, 2), 16)
  const g = Number.parseInt(full.slice(2, 4), 16)
  const b = Number.parseInt(full.slice(4, 6), 16)
  const safeAlpha = Math.min(Math.max(alpha, 0), 1)
  return `rgba(${r}, ${g}, ${b}, ${safeAlpha})`
}
